import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OnLand from "./pages/OnLand";
import AtSea from "./pages/AtSea";
import GridFreePower from "./pages/GridFreePower";
import Owner from "./pages/Owner";
import Sustainability from "./pages/Sustainability";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/on-land" element={<OnLand />} />
          <Route path="/at-sea" element={<AtSea />} />
          <Route path="/grid-free-power" element={<GridFreePower />} />
          <Route path="/about-owner" element={<Owner />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
